<div class="billing-settings-container">
    <div class="settings-header">
        <h2>CODING SETTINGS</h2>
        <p class="hint">MedicAI aims to completely automate all of your coding in realtime. Coding that relates to
            outpatient consults, inpatient ward coding, and procedure coding, can all be streamlined and automated.
            Setting codes for the wards in your hospital, setting code bundles for common procedures that you perform,
            and setting codes for your common modifiers will greatly assist in automating your patient coding. These
            codes can then be exported under the coding menu for your in-house billing or to be sent to your billing
            company.</p>
    </div>
    <mat-accordion multi="false">
        <mat-expansion-panel [expanded]="true" tutorialExpansionTarget="WARD_CODING">
            <mat-expansion-panel-header>
                <mat-panel-title>AUTOMATIC WARD CODING</mat-panel-title>
            </mat-expansion-panel-header>
            <p>Simplify your inpatient consult coding by assigning procedure codes to your wards. The assigned codes
                will be automatically applied to all patients within that ward on a daily basis, eliminating the need
                for manual coding and ensuring consistency and accuracy.</p>
            <app-auto-billing-settings></app-auto-billing-settings>
        </mat-expansion-panel>
        <mat-expansion-panel tutorialExpansionTarget="CODING_BUNDLE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    CODING BUNDLES
                    <mat-icon class="expansion-header-icon" (click)="openAddBundleDialog($event)"
                        matTooltip="Add a new coding bundle" color="primary"
                        tutorialHighlightTarget="CODING_BUNDLE">add</mat-icon>

                    <mat-icon *ngIf="isSupportUser" class="expansion-header-icon m-l-10"
                        (click)="codingBundleSettings.openImportCodingBundlesDialog($event)"
                        matTooltip="Import coding bundles from JSON" color="primary">upload</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p>Streamline your coding process by assigning a bundle of procedure codes to your existing Note Types.
                This allows you to easily extract the relevant codes when a specific note type is used, saving time and
                ensuring accurate coding.</p>
            <app-coding-bundle-settings #codingBundleSettings></app-coding-bundle-settings>
        </mat-expansion-panel>
        <mat-expansion-panel tutorialExpansionTarget="COMMON_MODIFIERS">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    COMMON MODIFIERS
                </mat-panel-title>
            </mat-expansion-panel-header>
            <p>Compile a list of common procedure code modifiers that you use often to have them suggested when
                generating AI notes.</p>
            <app-procedure-code-selector [initialCodes]="group.practiceModifers"
                (codesChanged)="onProcedureCodesChanged($event)" [modifiersOnly]="true"></app-procedure-code-selector>
        </mat-expansion-panel>

    </mat-accordion>
    <div class="mobile-spacer"></div>

</div>